import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

/**
 * Ein Link, der wie ein Button aussieht. Er kann entweder eine URL öffnen oder eine Funktion ausführen, wenn er angeklickt wird. Er kann auch deaktiviert werden und Tooltips anzeigen.
 */
@Component({
  selector: 'app-link-button',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './link-button.html',
  styleUrl: './link-button.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogLink {
  /** URL, auf die der Link zeigt. Alternativ kann onClick verwendet werden. Kann mit OnClick nicht gleichzeitig verwendet werden. */
  @Input() href?: string;
  /** Label, das im Dialog angezeigt wird, kann auch leer sein und z.B. nur mit Icons verwendet werden */
  @Input() label: string;
  /** Icon auf der linken Seite des Labels */
  @Input({ alias: 'icon' }) iconLeft?: string;
  /** Icon auf der rechten Seite des Labels */
  @Input() iconRight?: string;
  /** Gibt an, ob der Link deaktiviert ist */
  @Input() disabled = false;
  /** Ziel, in dem der Link geöffnet wird (z.B. _blank für neuen Tab) */
  @Input() target?: string;
  /** Tooltip-Text, der beim Überfahren mit der Maus angezeigt wird */
  @Input() tooltip?: string;
  /** Seite, auf der der Tooltip erscheint. PrimeNG-Standard ist 'right'. */
  @Input() tooltipPosition: 'right' | 'left' | 'top' | 'bottom' = 'right';
  /**
   * Zusätzliche Klassen für den Anker, z.B. 'p-button-text p-button-secondary'.
   * Nötig, weil eine class am Host-Element nicht auf dem inneren <a> landet.
   */
  @Input() styleClass = '';
}
